module.exports = __webpack_public_path__ + "media/images/icons/outlined/issues-close-f5c64f6dc9fd49f9ce9833faf9eb882b.svg";